module.exports = __webpack_public_path__ + "static/media/portfolio6-5.a24c394f.png";